import { render, staticRenderFns } from "./OCSShippingmark.vue?vue&type=template&id=2f78dfbd&scoped=true&"
import script from "./OCSShippingmark.vue?vue&type=script&lang=js&"
export * from "./OCSShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./OCSShippingmark.vue?vue&type=style&index=0&id=2f78dfbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f78dfbd",
  null
  
)

export default component.exports